import React from 'react'
import { Route } from 'react-router-dom';
import PrivateRoute from '../components/privateRoute'
import UnknownRouteFallback from '../components/unknownRouteFallback'
import RouteAccessManagement from '../pages/routeAccessManagement'
import Dashboard from '../pages/dashboard'
import FinanceOverview from '../pages/companyP&L/financeOverview'
import ApprovalForManualTransaction from '../components/approvalForManualTransaction'
// import ChangePasswordScreen from '../components/changePasswordScreen'
import CustomerInformation from '../components/customerInformation'
import OptimasationFilesView from '../pages/optimisationFiles/view'
import OptimasationFilesUpload from '../pages/optimisationFiles/upload'
import OpenPo from '../pages/companyP&L/openPos'
import BOM from '../pages/bom'
import StoreStocks from '../pages/store/stocks'
import ProjectDocuments from '../pages/design/projectDocuments'
// import SendToFinance from '../pages/design/sendToFinance'
import FinanceApprove from '../pages/finance'
import RawLeads from '../components/rawLeads'
import MetaLeads from '../pages/metaLeads'
import { MetaMarketingPage, GoogleMarketingPage } from '../pages/marketing/MarketingLeadsPage'
import Scoping from '../pages/scoping'
import Inwarding from '../pages/inwarding'
import ApprovePoSo from '../pages/companyP&L/approvePoSoMtr'
import ApprovePayments from '../pages/companyP&L/approvePayments'
import StorePayment from '../pages/store/payment'
import User from '../pages/userManagement/users'
import Roles from '../pages/userManagement/roles'
import Department from '../pages/userManagement/departments'
import Team from '../pages/userManagement/teams'
import Vendors from '../pages/vendorManagement/vendors'
import FactoryPayment from '../pages/factory/payment'
import FactoryStocks from '../pages/factory/stocks'
import MaterialTransfer from '../pages/materialTransfer'
import ManageCategory from '../pages/masterManagement/manageCategory'
import ManageScopes from '../pages/masterManagement/manageScopes'
import ManageUnits from '../pages/masterManagement/manageUnits'
import ManagePaymentModes from '../pages/masterManagement/managePaymentModes'
import ManageMiscPaymentServiceTypes from '../pages/masterManagement/miscPaymentServiceTypes'
import ManageMiscPaymentServiceCaps from '../pages/masterManagement/miscPaymentServiceCaps'
import ManageSubCategory from '../pages/masterManagement/manageSubCategory'
import ManageItems from '../pages/masterManagement/manageMaterials'
import ManageOrgRate from '../pages/masterManagement/manageOrgRate'
import DesignSignOffDocuments from '../pages/designSignOffDocuments'
import PaymentQrCode from '../pages/paymentQrCode'
import HoldRevokeMonitor from '../pages/holdRevokeMonitor'
import InwardingForProjects from '../pages/companyP&L/inwarding'
import InwardingForFactory from '../pages/factory/inwarding'
import InwardingForStore from '../pages/store/inwarding'
import FactoryOutwarding from '../pages/factory/outwarding'
import StoreOutwarding from '../pages/store/outwarding'
import QTProject from '../pages/qtProjects'
import Storelead from '../pages/storelead'
import ManageQTCustomer from '../pages/manageQTCustomer'
import ManageQuotation from '../pages/manageQuotation'
import ApproveVendorAndMaterialMapping from '../pages/vendorManagement/approveVendorAndMaterialMapping'
import manageProjectLog from '../pages/manageProjectLog'
import createLead from '../pages/leadCreation'
import SalesCreateLead from '../pages/leadCreation/salescreatenewlead.js'
import createNewCustomer from '../pages/leadCreationCustomer'
import marketingSource from '../pages/masterManagement/marketingSource'
import discountApproval from '../pages/discountApproval'
import marketingBudget from '../pages/marketingBudget'
import ShowStatusInformation from '../components/showStatusInfo'
import ManageProjectRate from '../pages/masterManagement/manageProjectRate'
import manageTarget from '../pages/masterManagement/manageTarget'
import managerCustomer from '../pages/customers/managerCustomer'
import ReminderReport from '../pages/reminder'
import Home from '../pages/home'
import AssignProjects from '../pages/customers/assignProject';
import MoveToDesign from '../pages/customers/moveToDesign';
import Location from '../pages/location'
import ExperienceCenter from '../pages/experienceCenter'
import DesignerAssignmentView from '../components/designerAssignmentView';
import leadApprovalView from '../components/leadApprovalView';
import ComplimentaryApprovalView from '../components/complimentaryApprovalView'
import CheckLists from '../components/checkList';
import manageDiscount from '../pages/masterManagement/manageDiscount';
import vendorPo from '../pages/vendorManagement/vendorPo'
import AllPo from '../pages/vendorManagement/vendorPo/allPo'

import BomMaterialForApproval from '../pages/bom/bomMaterialForApproval'
import LeadDesignToExecution from '../components/leadDesignToExecution';
import ContractSignLeads from '../pages/contractSignLead';
import VerifyDocuments from '../components/verifyDocuments';
import ValidateContractsDocuments from '../components/validateContractDocuments';
import SiteQcProjects from '../pages/siteQCProject';
import ManageSiteQcProjectLogs from '../pages/siteQCProject/projectlog';
import ReadyToDispatchProject from '../pages/readyToDispatchProject/projects';
import ManageReadyToDispatchProjectLogs from '../pages/readyToDispatchProject/projectLogs'
import ManageExecutionProjectLogs from '../pages/underExecution/projectlog'
import ViewCustomerCheckList from '../pages/viewChecklist';
import ProjectMaterilData from '../pages/siteQCProject/projectMaterial';
// import ViewCustomerCheckList from '../pages/viewChecklist';
// import TermsAndCondition from '../components/termAndCondition';
import TargetDetails from '../components/target-details';
import StageWiseLeads  from '../components/stagewiseleads'
import customerSurveyFormsList from '../pages/customerSurveyFormsList'

import Material_Return from '../pages/material/Material_Return'
import Approve_Material_Return from '../pages/material/Approve_Material_Return'
import RealFormDetails from '../pages/customerSurveyFormDetails';
import AddEditCheckList from '../pages/checklist';
import FinalPaymentApproval from '../components/finalPaymentApproval';
import ImosCompletedProjects from '../pages/siteQCProject/imosCompletedProject';
import imosDashboardStageDetails from '../components/imosDashboardStageDetails'
import ExecutionDashBoardDetail from '../components/executionDashBoardDetail'
import ExecutionDashBoardProjectDetail from '../components/executionDashBoardProjectDetails'
import DesignDashBoard from '../components/designstatistics'
import ContractLeads from '../components/contractlead'
import CHMLeads from '../pages/chmLeads'
import ChmUserLeads from '../pages/chmUserLeads'
import UnderExecutionProject from '../pages/underExecution/projects'
import Completed from '../pages/underExecution/projectcompleted'
import CompletedMWP from '../pages/underExecution/projectCompletedMWP'
import OperationOne from '../components/operationsOne';
// import DesignKickOff from '../pages/design_kick-off;
import DesignKickOff from '../pages/design_kick-off'
import SkpApprovals from '../pages/skpApprovalsPage'
import { useSelector } from 'react-redux';
import { ROLENAME, DESIGN_SIGN_OFF_DOC_EDITOR_ROLE_IDS, PAYMENT_QR_EDITOR_ROLE_IDS, CRON_MONITOR_ROLE_IDS, NOTIFICATION_SENDER_ROLE_IDS } from '../utils/index';
import CronJobMonitor from '../pages/cronJobMonitor'
import vendorSOManage from '../pages/vendorSOManage'
import callCenterLogs from '../components/callCenterLogs'
import InwardingInvoices from '../pages/InwardingInvoices/InwardingInvoices'
import ProjectCompletionStats from '../pages/StatisticsReport/ProjectCompletionStats'
import DesignSignOffStats from '../pages/StatisticsReport/DesignSignOffStats'
import MaterialDeliveryStats from '../pages/StatisticsReport/MaterialDeliveryStats'
import BookingStats from '../pages/StatisticsReport/BookingStats'
import MIS1 from '../pages/mis1/index'
import LeadsGenerated from '../pages/leadsGenerated/index'
import SourceOfLeadsDasboard from '../pages/sourceOfLeadsDashboard/index'
import SalesSummary from '../pages/salesSummary/index'
import DesignSummary from '../pages/designSummary/index'
import DesignStageDaysSummary from '../pages/designStageDaysSummary/index'
import DesignKickOffCustomerDaysSummary from '../pages/designKickOffCustomerDaysSummary/index'
import DesignKickOffInternalDaysSummary from '../pages/designKickOffInternalDaysSummary/index'
import CallingDesk from '../pages/callingDesk/index'
import CallingDeskResults from '../pages/callingDesk/results'
import InternalDSOSummary from '../pages/internalDesignSignOff/index'
import LostDataAnalysis from '../pages/lostDataAnalysis/index'
import DesignSignOffReview from '../pages/designSignOffReview/index'
import DesignHoldAnalysis from '../pages/designHoldAnalysis/index'
import MonthlyContractReview from '../pages/monthlyContractReview/index'
import OpsReview from '../pages/opsReviewDashboard/index'
import AiCallingAnalyticsDashboard from '../pages/aiCallingAnalyticsDashboard/index'
import MoveToMarketingClassifierDashboard from '../pages/moveToMarketingClassifierDashboard/index'
import BotWotWhatsAppDashboard from '../pages/BotWotWhatsAppDashboard/index'
import MissedCallReport from '../pages/MissedCallReport/index'
import PreProductionSummary from '../pages/preProductionSummary/index'
import ProductionSummary from '../pages/productionSummary/index'
import SummaryOfDelivery from '../pages/summaryOfDelivery/index'
import UnderExecutionSummary from '../pages/underExecutionSummary/index'
import MWPSummary from '../pages/mwpSummary/index'
import SummaryOfCompletion from '../pages/summaryOfCompletion/index'
import StageValue from '../pages/stageValue/index'
import paymentApprover from '../components/paymentApprover'
import paymentDetails from '../components/paymentDetails'
import hdfcVPC from '../components/hdfcVPC'
// import pendingInwardingApprovals from '../pages/pendingInwardingApprovals'
// import MultiCheckCreatePo from '../components/MultiCheckCreatePo'
import customerInformation from '../components/customerInformation'
import MultiCheckCreatePo from '../components/MultiCheckCreatePo'
import PaymentGenrateLink from '../components/PaymentGenrateLink'
import WorkingDrawingReceived from '../components/WorkingDrawingReceived'
import FactoryReviewSheet from '../pages/FactoryReviewSheet'
import QtChangesApproval from '../pages/QtChangesApproval'
import LostLeadApprovalView from '../components/LostLeadApprovalView'
import chmTicketForm from '../pages/chmTicketForm'
import CHMuserDashboard from '../pages/CHMuserDashBoard'
import ChmAddTicketCategory from '../components/chmAddTicketCategory'
import CustomerLoginActivity from '../pages/cx_customer/customerLoginActivity'
import ErpLoginActivity from '../pages/erp_user/erpLoginActivity'
import DesignHoldView from '../components/DesignHoldView'
import UserAccessManagement from '../components/userAccessMangement'
import leadToMeeting from '../components/leadToMeeting'
import leadToOrder from '../components/leadToOrder'
import meetingToOrder from '../components/meetingToOrder'
import leadInMarketing from '../components/leadInMarketing'
import leadCriteria from '../components/leadCriteria'
import TatInternalTicket from '../components/tatInternalTicket'
import EscalationMatrix from '../components/escalationMatrix'
import FaqCreation from '../components/faqCreation'
import CxStageSetting from '../pages/cxStageSetting'
import WhatsApp_Stages_Operations from '../pages/whatsapp_stages_operations'
import WhatsApp_Stages_Marketing from '../pages/whatsapp_stages_marketing'
import WhatsApp_Stages_Sales from '../pages/whatsapp_stages_sales'
import downloadCenter from '../components/downloadCenter'
import DesignHoldApprovalView from '../components/designHoldApproval.js';
import ApprovedPaymentReceivedAnalysis from '../pages/ApprovedPaymentReceivedAnalysis/index.js'
import KnowLedgeHub from '../components/knowLedgeHub'
import callCenterDashboard from '../components/callCenterDashboard.js'
import TaskManagementDashBoard from '../pages/TaskManagementDashBoard'
import RefundRequestApprovalView from '../components/refundRequestApprovalView'
import RefundApprovalBypass from '../components/refundApprovalBypass'
import RaiseRefundRequest from '../components/raiseRefundRequest'
import RaiseQuotationChangeRequest from '../pages/raiseQuotationChangeRequest'
import RefundApproval from '../components/refundApproval'
import GenerateBarcode from '../components/generateBarcode.js'
import ScanBarcode from '../components/scanBarcode.js'
import DesignHoldRevokeAnalysis from '../pages/designHoldRevokeAnalysis/index'
import SalesTarget from "../components/SalesTarget.js";
import PerformanceSales from "../components/PerformanceSales.js";
import NewInwardingApprovals from "../pages/NewInwardingApprovals/index.js";
import PendingInwardingApprovals from "../pages/PendingInwardingApprovals/index.js";
import EditedInwardingApprovals from "../pages/EditedInwardingApprovals/index.js";
import RaisePaymentRequests from "../pages/RaisePaymentRequests/index.js";
import RejectedInwarding from "../pages/RejectedInwarding/index.js";
import POEditRequests from '../pages/POEditRequests/index.js';
import PaymentRequestApproval from '../pages/PaymentRequestApproval/index.js'
import InwardingFreightApproval from '../pages/InwardingFreightApproval/index.js';
import PaymentExcelDownload from '../pages/PaymentExcelDownload/index.js';
import FactoryFinanceExecutive from '../pages/FactoryFinanceExecutive/index.js';
import DownloadGRN from '../pages/DownloadGRN/index.js';
import POEditRequestsL1 from '../pages/POEditRequestsL1/index.js';
import ParentComponent from '../pages/LeadBuilder/Assembly.js'
import StageReview from '../pages/stageReview/index';
import leadsAssigned from '../components/leadsAssigned'
import CurrentMonthPipelineDashboard from '../pages/currentMonthPipelineDashboard/index';
import ProjectionAcvDashboard from '../pages/projectionAcvDashboard/index'
import MeetingTrackerDashboard from '../pages/meetingTrackerDashboard'
import RncRevivalDashboard from '../pages/RNCRevival'
import SalesLostRevivalDashboard from '../pages/SalesLostRevival'
import ExpectedClosureTracker from '../pages/expectedClosureTracker';
import ReminderDashboard from '../pages/reminderDashboard'
import Incentives from '../components/Incentives.js'
import TeamUserLogs from '../pages/teamUserLogs/index.js'
import MoveToMarketingApproval from '../pages/moveToMarketingApproval/index.js'
import ProjectManagementDashboard from '../components/ProjectManagementDashboard.js'
import CreateProject from '../components/CreateProject.js'
import SalesUserHomePage from '../pages/salesUserHomePage'
import TaskManagementNotesDashboard from '../pages/TaskManagementNotesDashboard'
import MaterialPriceChangeDetails from "../pages/MaterialPriceChangeDetails/index.js";
import SalesUserWonDealPending from '../components/SalesUserWonDealPending'
import Referral from '../components/Referal.js'
import SalesUserLeadMetrics from '../pages/SalesUserLeadMetrics'
import CallRecordingsUntagged from '../pages/callRecordings/untaggedLogs';
import CallRecordingsTagged from '../pages/callRecordings/taggedLogs';
import CallLogsForLead from '../pages/callRecordings/leadCallLogs';
import TaxInvoicesListing from '../pages/taxInvoices';
import CallReport from '../pages/callRecordings/callReport';
import MaterialsCheckListApprovals from '../pages/materialsChecklistApprovals'
import ApproveStdRateOfMaterial from '../components/ApproveStdRateOfMaterial'
import Reports from '../components/Reports'
import IncomingWhatsAppMessages from '../components/IncomingWhatsAppMessages.js'
import TargetForDesignTeam from "../components/TargetForDesignTeam.js"
import PerformanceForDesignTeam from '../components/PerformanceForDesignTeam.js'
import IncentiveForDesignTeam from '../components/IncentiveForDesignTeam.js'
import MyProjectManagementDashboard from '../components/MyProjectManagementDashboard.js'
import CapexProjectCreation from '../components/CapexProjectCreation.js'
import SnagSeriesCreation from '../components/SnagSeriesCreation.js'
import CapexProjectApproval from '../components/CapexProjectApproval.js'
import OverheadProjectApproval from '../components/OverheadProjectApproval.js'
import OverheadProjectCreation from '../components/OverheadProjectCreation.js'
import InTransit from '../pages/readyToDispatchProject/inTransit/index.js'
import ScanPackageReport from '../components/scanPackageReport.js'
import ScanPiece from '../components/scanPiece.js'
import AutomationLeadDashboard from '../pages/automationLeadDashboard/index';
import RedirectEC from '../pages/redirectEC/index';
import logDetailed from "../pages/logDetailed/logDetailed.js"
import MonthlyConversionGoals from '../components/MonthlyConversionGoals.js'
import inwardingLockDate from '../components/inwardingLockDate.js'
import OperationStage from '../components/ServiceOrderPaymentRaise/OperationStage.js'
import VendorPaymentSO from "../pages/vendorPaymentSnorkelHDFC/vendorSOPayment.js"
import VendorPaymentPO from "../pages/vendorPaymentSnorkelHDFC/vendorPOPayment.js"
import HDFCResponse from "../pages/vendorPaymentSnorkelHDFC/ReverseFileViewer.js"
import DrawingQcApproval from '../pages/DrawingQcApproval/index.js'
import AdmCheckList from '../pages/DrawingQcApproval/AdmCheckList.js'
import OverviewQCTable from '../pages/DrawingQcApproval/OverviewQCTable.js'
import DrawingQCTable from '../pages/DrawingQcApproval/DrawingQCTable.js'
import DrawingQCLogs from '../pages/manageProjectLog/DrawingQCLogs.js'
import DesignHealth from '../pages/DesignHealth/index.js'
import DesignHealthMDaySummary from '../pages/designHealthMDaySummary/index.js'
import OdmAgmMyCommitments from '../pages/OdmAgmMyCommitments/OdmAgmMyCommitments.jsx'
import OdmAgmPendingTask from '../pages/OdmAgmMyCommitments/odmAgmPendingTask.jsx'
import OdmAgmPerformanceDashboard from '../pages/OdmAgmMyCommitments/OdmAgmPerformanceDashboard.jsx'
import MyTeamPerformance from '../pages/OdmAgmMyCommitments/MyTeamPerformance.jsx'
import TeamBandwidth from '../pages/OdmAgmMyCommitments/TeamBandwidth.jsx'
import OdmAgmApprovals from '../pages/OdmAgmMyCommitments/OdmAgmApprovals.jsx'
import OdmAgmSummaryDashboard from '../pages/OdmAgmMyCommitments/OdmAgmSummaryDashboard.jsx'
import MonthlyContract from '../pages/DesignHealth/monthlyContract.js'
import CommitmentApprovalForADM from '../pages/DesignHealth/CommitmentApprovalForADM.js'
import FreezeProjects from '../pages/DesignHealth/FreezeProjects.js'
import PartnersImg from "../components/partnersImg.js"
import socialMediaWebQuotation from "../components/socialMediaWebQuotation.js"
import CostSummarySection from '../components/CostSummarySection.js'
import whyChooseUsNew from '../components/whyChooseUsNew.js'
import customerTestimonials from '../components/customerTestimonials.js'
import galleryWebQuotation from '../components/galleryWebQuotation.js'
import CostBreakDownSection from '../components/CostBreakDownSection.js'
import InactiveUserLeadsDashboard from '../pages/InactiveUserLeadsDashboard'
import flaggedProject from "../components/flaggedProject.js"
import ViewSnag from '../components/viewSnag.js'
import SpendReport from '../pages/spendReport/index.js';
import SpendReportValues from '../pages/spendReport/values.js';
import ManualReferral from '../pages/ReferralSettings/manualReferral.js'
import DesignQuoteApprovalPage from '../components/DesignQuoteApprovalPage.js'
import DsoPaymentApprovalPage from '../components/DsoPaymentApprovalPage.js'
import DesignNewSummary from '../pages/designNewSummary'
import commitmentTasks from "../components/commitmentTasks.js"
import PerformanceDashboardDesignTeam from '../components/performanceDashboardForDesignEx.js';
import Approval from '../components/DesignApproval.js';
import LeadFromMeetingToOrder from '../components/LeadFromMeetingToOrder.js'
import ASMDashboard from '../components/AsmDashboardTable.js'
import LeadLifeCycle from '../pages/LeadLifeCycle';
import ChannelPartner from '../pages/ChannelPartnerDashboard';
import ChannelPartnerPerformance from '../pages/ChannelPartnerPerformance/index.js';
import WhatsAppCampaign from '../pages/WhatsAppCampaignDashboard';
import HoomanAvailabilityDashboard from '../pages/HoomanAvailabilityDashboard';
import HoldDashboard from '../pages/HoldDashboard';
import InitiationBomDataTable from '../pages/BomSegregation/InitiationBomDataTable.jsx'
import MarketingToBeCalled from '../components/MarketingToBeCalled'
import MarketingOnHold from '../components/MarketingOnHold'
import MarketingOnNTBCHold from '../components/MarketingOnNTBCHold'
import MarketingJunk from '../components/MarketingJunk'
import LeadReturnBySale from '../components/LeadReturnBySales.js'
import bomSegregation from '../pages/BomSegregation/index.jsx'
import addGSTPage from '../pages/finance/addGstPage/index.js'
import updateSalesWonDate from '../components/updateSalesWonDate.js'
import MyNotifications from '../pages/myNotifications'
import SalesOverallComparison from "../components/SalesOverallComparison.js"
import LeadHealthAnalytics from '../components/Dashboard.jsx'
import ERPSMainPage from '../pages/EmployeeRewardsPointsSystem/index.jsx'
import RewardConfig from '../pages/EmployeeRewardsPointsSystem/RewardConfig';
import ChannelPartnerMeetingData from '../components/ChannelPartnerMeeting'
import XoxodayForm from '../pages/Xoxoday/xoxodayForm';
import FurnitureOne from '../pages/FurnitureOne/FurnitureOne.js'
import FurnitureOneItemDetails from '../pages/FurnitureOne/FurnitureOneItemDetails.js'
import FurnitureOneApproval from '../pages/FurnitureOne/FurnitureOneApproval.js'
import updateFurnitureOneItems from '../pages/FurnitureOne/updateItems.js'
import hrStatusColorCode from '../components/hrStatusColorCode.js'
import roster from '../components/roster.js'
import hrRacksheetOverallSummary from '../components/hrRacksheetOverallSummary.js'
import hrRacksheetSummaryByCity from '../components/hrRacksheetSummaryByCity.js'
import hrRacksheetOpenReq from '../components/hrRacksheetOpenReq.js'
import hrRacksheetAtRisk from '../components/hrRacksheetAtRisk.js'
import hrRacksheetDesignHierarchy from '../components/hrRacksheetDesignHierarchy.js'
import hrRacksheetSalesHierarchy from '../components/hrRacksheetSalesHierarchy.js'
import hrRacksheetOpsHierarchy from '../components/hrRacksheetOpsHierarchy.js'
import hrRacksheetSummaryByEC from '../components/hrRacksheetSummaryByEC.js'
import RfdExecutiveDashboarad from '../pages/RfdDashboarad/rfdExecutiveDashboard.js'
import ManagerDashboard from '../pages/RfdDashboarad/rfdMangerDashboard.js'
import FullPackageDelivered from '../pages/fullPackageDelivered'
import PartialPackageDelivered from '../pages/partialPackageDelivered'
import PanelDeliveryReports from '../pages/panelDeliveryReports'
import SnagDetails from '../pages/snagDetails/index'
import HardwareSnags from '../pages/hardwareSnags/index'
import HardwareBomViewer from '../pages/hardwareBomViewer/index'
import ProductionSummaryProject from '../pages/productionSummaryProject/index'
import ExecutionApprovalList from '../pages/underExecution/ExecutionApprovalList/index.js';
import hrRacksheetActivityLogDashboard from "../components/hrRacksheetActivityLogDashboard.js"
import KekaRoles from '../pages/userManagement/kekaRoles'
import KekaDepartments from '../pages/userManagement/kekaDepartments'
import KekaCities from '../pages/userManagement/kekaCities'
import KekaExperienceCenters from '../pages/userManagement/kekaExperienceCenters'
import VendorLogs from '../pages/vendorManagement/vendorLogs'
// all misc payment related Routes..
import RentalOwnerOnboarding from '../pages/MiscellaneousPayments/ownerOnboarding.js'
import MiscPaymentRaise from '../pages/MiscellaneousPayments/miscPaymentRaise.js'
import OnboardingApprovalStatusView from '../pages/MiscellaneousPayments/onboardingApprovalStatusView.js'
import PaymentRaisedStatusView from '../pages/MiscellaneousPayments/paymentRaisedStatusView.js'
import OnboardningRaiseApproval from '../pages/MiscellaneousPayments/onboarding&PaymentRequestApproval.js'
import MiscpaymentMasterDashboard from '../pages/MiscellaneousPayments/miscpaymentMasterDashboard.js'
import MiscpaymentMasterFinanceDashboard from '../pages/MiscellaneousPayments/miscpaymentMasterFinanceDashboard.js'
import RentalPaymentDashboardComparison from '../pages/MiscellaneousPayments/RentalPaymentDashboardComparison.js'
import AdhocDashboard from '../pages/companyP&L/adhocDashboard'
import ApprovalCenter from '../pages/ApprovalCenter'
import GstPaymentApproval from '../components/ServiceOrderPaymentRaise/GstPaymentApproval.js'
import StockMovement from '../pages/stockMovement/index.js'
import StockMovementLog from '../pages/stockMovementLog/index.js'
import pushToProd from '../pages/pushToProd/index.jsx';
import CacheSessionManagement from '../pages/cacheSessionManagement/index.jsx';
import ChannelPartnerOnboarding from '../pages/MiscellaneousPayments/channelPartnerOnboarding.js'
import MoqAndOrders from '../pages/MoqAndOrders'
import leadAccessGrants from '../pages/leadAccessGrants'
import SendNotification from '../pages/sendNotification'
import discountApprovalHistory from '../pages/discountApprovalHistory'

const Index = () => {
	const { userDetails } = useSelector(state => state.user)
	const canEditSignOffDocs = (userDetails?.roles || [])
		.some(role => DESIGN_SIGN_OFF_DOC_EDITOR_ROLE_IDS.includes(String(role?._id)))
	const canEditPaymentQr = (userDetails?.roles || [])
		.some(role => PAYMENT_QR_EDITOR_ROLE_IDS.includes(String(role?._id)))
	const canSeeCronMonitor = (userDetails?.roles || [])
		.some(role => CRON_MONITOR_ROLE_IDS.includes(String(role?._id)))
	const canSendNotifications = (userDetails?.roles || [])
		.some(role => NOTIFICATION_SENDER_ROLE_IDS.includes(String(role?._id)))
	const roles = userDetails?.roles || []
	return (
		<>
			{roles.find(role => role.name === ROLENAME.SalesUser) ?
				<PrivateRoute component={SalesUserHomePage} path="/dashboard" exact />
				:
				roles.find(role => role.name === ROLENAME.AssistantSalesManager) ?
					<PrivateRoute component={ASMDashboard} path="/dashboard" exact />
					: roles.find(role => role.name === ROLENAME.DesignUser) ?
						<PrivateRoute component={commitmentTasks} path="/dashboard" exact /> :
						<PrivateRoute component={Dashboard} path="/dashboard" exact />
			}
			<PrivateRoute component={LeadFromMeetingToOrder} path="/performance_target" exact />
			<PrivateRoute component={TatInternalTicket} path="/tat-internal-ticket" exact />
			<PrivateRoute component={EscalationMatrix} path="/escalation-matrix" exact />
			<PrivateRoute component={ViewSnag} path="/view-snag-report" exact />
			<PrivateRoute component={SalesUserLeadMetrics} path="/lead-metrics" exact />
			<PrivateRoute component={SkpApprovals} path="/skpApprovals" exact />
			<PrivateRoute component={GenerateBarcode} path="/generate-barcode" exact />
			<PrivateRoute component={ScanBarcode} path="/scan-barcode" exact />
			<PrivateRoute component={downloadCenter} path="/download-center" exact />
			{/* Start - Payment Integration */}
			<PrivateRoute component={paymentDetails} path="/paymentDetails" exact />
			<PrivateRoute component={hdfcVPC} path="/hdfc-virtual-payment" exact />
			{/* End - Payment Integration */}
			<PrivateRoute component={KnowLedgeHub} path="/knowledge_hub" exact />
			<PrivateRoute component={DesignDashBoard} path="/designstats" exact />
			<PrivateRoute component={ContractLeads} path="/contractleads" exact />
			<PrivateRoute component={QTProject} path="/qtProjects" exact />
			<PrivateRoute component={InactiveUserLeadsDashboard} path="/inactive-user-leads-dashboard" exact />
			<PrivateRoute component={FinanceOverview} path="/companyP&L/financeOverview" exact />
			<PrivateRoute component={AdhocDashboard} path="/companyP&L/adhocDashboard" exact />
			<PrivateRoute component={CustomerInformation} path="/financeApprovalScreen&L/customerInformation" exact />
			<PrivateRoute component={ApprovalForManualTransaction} path="/financeApprovalScreen&L/approvalForManualTransaction" exact />
			<PrivateRoute component={ApprovedPaymentReceivedAnalysis} path="/financeApprovalScreen&L/approved-payment-receipts" exact />
			{/* <PrivateRoute component={ChangePasswordScreen} path="/change_password" exact /> */}
			{/* <Route component={ChangePasswordScreen} path="/change_password" exact /> */}
			<PrivateRoute component={OptimasationFilesView} path="/optimisation_files/view" exact />
			<PrivateRoute component={OptimasationFilesUpload} path="/optimisation_files/upload" exact />
			{
				(userDetails.roles?.find(role =>role.name === "Operation Head" || role.name === "Finance Executive" || role.name === "Finance Manager") && 
				<>
			<PrivateRoute component={ApprovePoSo} path="/companyP&L/approvePoSoMtr" exact />
			   </>
				)
			}			
			<PrivateRoute component={ApprovePayments} path="/companyP&L/approvePayments" exact />
			<PrivateRoute component={RawLeads} path="/raw-leads" exact />
			<PrivateRoute component={MetaLeads} path="/meta-leads" exact />
			<PrivateRoute component={MetaMarketingPage} path="/marketing/meta-leads" exact />
			<PrivateRoute component={MetaMarketingPage} path="/marketing/meta-ads" exact />
			<PrivateRoute component={GoogleMarketingPage} path="/marketing/google-ads" exact />
			<PrivateRoute component={InwardingForProjects} path="/companyP&L/inwarding" exact />
			<PrivateRoute component={OpenPo} path="/companyP&L/openPo" exact />
			<PrivateRoute component={ProjectDocuments} path="/uploadProjectDocuments" exact />
			{/* <PrivateRoute component={SendToFinance} path="/design/sendToFinance" exact /> */}
			<PrivateRoute component={FinanceApprove} path="/finance" exact />
			<PrivateRoute component={Scoping} path="/scoping" exact />
			<PrivateRoute component={Inwarding} path="/inwarding" exact />
			<PrivateRoute component={StoreStocks} path="/store/stocks" exact />
			<PrivateRoute component={StorePayment} path="/store/payments" exact />
			<PrivateRoute component={InwardingForStore} path="/store/inwarding" exact />
			<PrivateRoute component={StoreOutwarding} path="/store/outwarding" exact />
			<PrivateRoute component={FactoryStocks} path="/factory/stocks" exact />
			<PrivateRoute component={InwardingForFactory} path="/factory/inwarding" exact />
			<PrivateRoute component={FactoryOutwarding} path="/factory/outwarding" exact />
			<PrivateRoute component={FactoryPayment} path="/factory/payments" exact />
			<PrivateRoute component={BOM} path="/bom" exact />
			<PrivateRoute component={User} path="/userManagement/users" exact />
			<PrivateRoute component={Roles} path="/userManagement/roles" exact />
			<PrivateRoute component={Department} path="/userManagement/departments" exact />
			<PrivateRoute component={Team} path="/userManagement/teams" exact />
			<PrivateRoute component={Vendors} path="/vendorManagement/vendors" exact />
			<PrivateRoute component={vendorPo} path="/vendor_po" exact />
			<PrivateRoute component={AllPo} path="/vendor_po/all" exact />
			<PrivateRoute component={MaterialTransfer} path="/materialTransfer" exact />
			<PrivateRoute component={ManageQTCustomer} path="/manage-customer/:customerId" exact />
			<PrivateRoute component={ManageCategory} path="/masterManagement/manageCategory" exact />
			<PrivateRoute component={ManageScopes} path="/masterManagement/manageScope" exact />
			<PrivateRoute component={ManageUnits} path="/masterManagement/manageUnit" exact />
			<PrivateRoute component={ManagePaymentModes} path="/masterManagement/managePaymentModes" exact />
			<PrivateRoute component={ManageSubCategory} path="/masterManagement/manageSubCategory" exact />
			<PrivateRoute component={ManageItems} path="/masterManagement/manageItems" exact />
			{/* <PrivateRoute component={ManageItems} path="/masterManagement/manageItems" exact /> */}
			<PrivateRoute component={ManageOrgRate} path="/masterManagement/manageOrgRate" exact />
			{canEditSignOffDocs &&
				<PrivateRoute component={DesignSignOffDocuments} path="/design-sign-off-documents" exact />}
			{canEditPaymentQr &&
				<PrivateRoute component={PaymentQrCode} path="/payment-qr-code" exact />}
			<PrivateRoute component={HoldRevokeMonitor} path="/hold-revoke-monitor" exact />
			{canSeeCronMonitor &&
				<PrivateRoute component={CronJobMonitor} path="/cron-job-monitor" exact />}
			{canSendNotifications &&
				<PrivateRoute component={SendNotification} path="/send-notification" exact />}
			<PrivateRoute component={ManageProjectRate} path="/masterManagement/manageProjectRate" exact />
			<PrivateRoute component={MaterialPriceChangeDetails} path="/masterManagement/material-price-change-details" exact />
			<PrivateRoute component={ManageQuotation} path="/manageQuotations/:leadId" exact />
			{
				(userDetails.roles?.find(role =>role.name === "Operation Head" || role.name === "Finance Executive" || role.name === "Finance Manager") && 
				<>
			<PrivateRoute component={ApproveVendorAndMaterialMapping} path='/vendorManagement/approveVendorsAndMaterialMapping' exact />
			   </>
				)
			}	
			<PrivateRoute component={manageProjectLog} path="/project-logs/:projectId" exact />
			<PrivateRoute component={createLead} path="/create-new-lead" exact />
			<PrivateRoute component={SalesCreateLead} path="/sales-create-new-lead" exact />
			<PrivateRoute component={createNewCustomer} path="/create-new-customer" exact />
			<PrivateRoute component={CxStageSetting} path="/customer-app-designstage-setting" exact />
			<PrivateRoute component={WhatsApp_Stages_Operations} path="/whatsapp-stages-operations" exact />
			<PrivateRoute component={WhatsApp_Stages_Marketing} path="/whatsapp-stages-marketing" exact />
			<PrivateRoute component={WhatsApp_Stages_Sales} path="/whatsapp-stages-sales" exact />

			<PrivateRoute component={marketingSource} path="/masterManagement/marketing-sources" exact />
			<PrivateRoute component={discountApproval} path="/discount-approval" exact />
			{/* {
			(userDetails?.roles?.find(role =>role.name === "Assistant Design Manager" || role.name === 'Operation Manager' || role.name === 'Finance Manager' || role.name === 'Design Manager' || role.name === 'Operation Design Manager' || role.name === 'DGM Ops') && 
			<> */}
				<PrivateRoute component={QtChangesApproval} path="/lead-quotation-changes-approval" exact />
			{/* </>
			)
			} */}
			<PrivateRoute component={marketingBudget} path="/set-marketing-budget" exact />
			<PrivateRoute component={ShowStatusInformation} path="/status-information/:statusName/:startDate/:endDate/:check/:isUser" exact />
			<PrivateRoute component={manageTarget} path="/set-team-target" exact />
			<PrivateRoute component={Location} path="/location" exact />
			<PrivateRoute component={ExperienceCenter} path="/experienceCenter" exact />
			<PrivateRoute component={managerCustomer} path="/customer/manager-customer" exact />
			<PrivateRoute component={ReminderReport} path="/reminder" exact />
			<PrivateRoute component={Home} path="/home" exact />
			<PrivateRoute component={AssignProjects} path="/customer/assign-lead" exact />
			<PrivateRoute component={MoveToDesign} path="/customer/move-to-design" exact />
			<PrivateRoute component={DesignerAssignmentView} path="/designer-assignment/:statusName/:startDate/:endDate/:userId/:isUser" exact />
			<PrivateRoute component={leadApprovalView} path="/lead-approval" exact />
			<PrivateRoute component={ComplimentaryApprovalView} path="/complimentary-approval" exact />
			<PrivateRoute component={LostLeadApprovalView} path="/lost-approvals" exact />
			<PrivateRoute component={DesignQuoteApprovalPage} path="/design-quote-approval-view" exact />
			<PrivateRoute component={DsoPaymentApprovalPage} path="/dso-payment-approval" exact />
			<PrivateRoute component={leadCriteria} path="/lead-criteria" exact />
			<PrivateRoute component={FaqCreation} path="/faq-details" exact />
			<PrivateRoute component={DesignHoldView} path="/design-signoff-hold-projects" exact />
			<PrivateRoute component={CheckLists} path="/check-lists" exact />
			<PrivateRoute component={manageDiscount} path="/manage-discount" exact />
			{
				(userDetails.roles?.find(role => role.name === ROLENAME.OperationHead || role.name === "BOM Manager" ) && 
				<>
			<PrivateRoute component={BomMaterialForApproval} path="/bom/materialsForApproval" exact />
			   </>
				)
			}		
			<PrivateRoute component={LeadDesignToExecution} path="/lead-design-to-execution/:startDate/:endDate" exact />
			<PrivateRoute component={DesignHoldApprovalView} path="/lead-design-hold-approval" exact />
			<PrivateRoute component={ContractSignLeads} path="/contract-sign-leads" exact />
			<PrivateRoute component={VerifyDocuments} path="/verify-documents/:leadId" exact />
			<PrivateRoute component={ValidateContractsDocuments} path="/validate-contract-documents/:leadId" exact />
			<PrivateRoute component={SiteQcProjects} path="/siteqc/projects" exact />
			<PrivateRoute component={ManageSiteQcProjectLogs} path="/siteqc/project-detail/:projectId" exact />
			<PrivateRoute component={ReadyToDispatchProject} path="/ready-to-dispatch-project" exact />
			<PrivateRoute component={ManageReadyToDispatchProjectLogs} path="/ready-to-dispatch-project/log/:projectId" exact />
			{/* <PrivateRoute component={ManageExecutionProjectLogs} path="/underexecution-project/logs/:projectId" exact /> */}
			<PrivateRoute component={ManageExecutionProjectLogs} path="/:pageName/logs/:projectId" exact />
			<PrivateRoute component={ViewCustomerCheckList} path="/view-customer-checklist/:leadId" exact />
			<PrivateRoute component={ProjectMaterilData} path="/project-materials-details" exact />
			{/* <PrivateRoute component={CustomerPrivewQuotationView} path="/final-quotation-customer-approval" exact /> */}
			{/* <PrivateRoute component={ViewCustomerCheckList} path="/view-customer-checklist/:leadId" exact /> */}
			{/* <PrivateRoute component={TermsAndCondition} path="/terms-and-condition" exact /> */}
			<PrivateRoute component={TargetDetails} path="/target-details" exact />
			<PrivateRoute component={StageWiseLeads} path="/Sales-lead-wise-total-data" exact />
			<PrivateRoute component={customerSurveyFormsList} path="/view-customer-survey-forms" exact />
			<PrivateRoute component={Material_Return} path="/material_return" exact />
			{
				(userDetails.roles?.find(role => role.name === ROLENAME.OperationHead ) && 
				<>
			<PrivateRoute component={Approve_Material_Return} path="/approve_material_return" exact />
			   </>
				)
			}
			<PrivateRoute component={RealFormDetails} path="/customer-survey-form-details" exact />
			<PrivateRoute component={AddEditCheckList} path="/add-checklist" exact />
			<PrivateRoute component={FinalPaymentApproval} path="/final-payment-approval" exact />
			<PrivateRoute component={ImosCompletedProjects} path="/siteqc/completed-projects" exact />
			<PrivateRoute component={imosDashboardStageDetails} path="/imos-stage-projects/:imosStage" exact />
			<PrivateRoute component={ExecutionDashBoardDetail} path="/execution-stage-projects/:executionStage" exact />
			<PrivateRoute component={ExecutionDashBoardProjectDetail} path="/execution-dashboard-projects/:executionStage" exact />
			<PrivateRoute component={CHMLeads} path="/chm-leads" exact />
			<PrivateRoute component={ChmUserLeads} path="/chm-user-leads/:chmUserId" exact />
			<PrivateRoute component={UnderExecutionProject} path="/under-execution-project" exact />
			<PrivateRoute component={Completed} path="/project-completed" exact />
			<PrivateRoute component={CompletedMWP} path="/project-Completed-MWP" exact />
			<PrivateRoute component={Storelead} path="/store-lead" exact />
			<PrivateRoute component={vendorSOManage} path="/vendor-so-manage" exact />
			<PrivateRoute component={callCenterLogs} path="/call-center-logs" exact />
			<PrivateRoute component={InwardingInvoices} path="/inwarding-invoices" exact />

			{/* Routes for Statistics SubMenu */}
			<PrivateRoute component={BookingStats} path="/designstats/design-review-sheet" exact />
			<PrivateRoute component={MIS1} path="/mis1-dashboard" exact />
			<PrivateRoute component={LeadsGenerated} path="/leads-generated" exact />
			<PrivateRoute component={SourceOfLeadsDasboard} path="/source-of-leads-dashboard" exact />
			<PrivateRoute component={SalesSummary} path="/sales-summary" exact />
			<PrivateRoute component={DesignSummary} path="/design-summary" exact />
			<PrivateRoute component={DesignStageDaysSummary} path="/design-stage-days-summary" exact />
			<PrivateRoute component={DesignKickOffCustomerDaysSummary} path="/design-kickoff-customer-days-summary" exact />
			<PrivateRoute component={DesignKickOffInternalDaysSummary} path="/design-kickoff-internal-days-summary" exact />
			<PrivateRoute component={CallingDesk} path="/calling-desk" exact />
			<PrivateRoute component={CallingDeskResults} path="/calling-desk/results" exact />
			<PrivateRoute component={InternalDSOSummary} path="/internal-dso-summary" exact />
			<PrivateRoute component={LostDataAnalysis} path="/lost-data-analysis" exact />
			<PrivateRoute component={DesignSignOffReview} path="/designSignOff-review" exact />
			<PrivateRoute component={DesignHoldAnalysis} path="/designHold-analysis" exact />
			<PrivateRoute component={MonthlyContractReview} path="/monthly-contract-review" exact />
			<PrivateRoute component={OpsReview} path="/ops-review" exact />
			<PrivateRoute component={AiCallingAnalyticsDashboard} path="/ai-calling-analytics" exact />
			<PrivateRoute component={MoveToMarketingClassifierDashboard} path="/move-to-marketing-ai-review" exact />
			<PrivateRoute component={BotWotWhatsAppDashboard} path="/botwot-whatsapp-funnel" exact />
			<PrivateRoute component={MissedCallReport} path="/missed-call-report" exact />
			<PrivateRoute component={PreProductionSummary} path="/pre-production-summary" exact />
			<PrivateRoute component={ProductionSummary} path="/production-summary" exact />
			<PrivateRoute component={SummaryOfDelivery} path="/summary-of-delivery" exact />
			<PrivateRoute component={UnderExecutionSummary} path="/under-execution-summary" exact />
			<PrivateRoute component={MWPSummary} path="/mwp-summary" exact />
			<PrivateRoute component={SummaryOfCompletion} path="/summary-of-completion" exact />
			<PrivateRoute component={StageValue} path="/stage-value" exact />
			<PrivateRoute component={DesignHoldRevokeAnalysis} path="/designHold-revoke-analysis" exact />
			{/* <PrivateRoute component={DesignSignOffStats} path="/designstats/design-sign-off" exact />
			<PrivateRoute component={MaterialDeliveryStats} path="/designstats/material-delivery" exact />
			<PrivateRoute component={ProjectCompletionStats} path="/designstats/project-completion" exact /> */}
			<PrivateRoute component={paymentApprover} path="/payment-approver" exact />
			<PrivateRoute component={DesignKickOff} path="/design_kick-off" exact />
			<PrivateRoute component={PendingInwardingApprovals} path="/finance-factory-inwarding/pendingInwardingApprovals" exact />
			<PrivateRoute component={NewInwardingApprovals} path="/finance-factory-inwarding/newInwardingApprovals" exact />
			<PrivateRoute component={EditedInwardingApprovals} path="/finance-factory-inwarding/editedInwardingApprovals" exact />
			<PrivateRoute component={RaisePaymentRequests} path="/finance-factory-inwarding/raisePaymentRequest" exact />
			<PrivateRoute component={PaymentRequestApproval} path="/finance-factory-inwarding/paymentRequestApproval" exact />
			<PrivateRoute component={InwardingFreightApproval} path="/finance-factory-inwarding/inwardingFreightApproval" exact />
			<PrivateRoute component={PaymentExcelDownload} path="/finance-factory-inwarding/paymentExcelDownload" exact />
			<PrivateRoute component={FactoryFinanceExecutive} path="/finance-factory-inwarding/factoryFinanceExecutive" exact />
			<PrivateRoute component={RejectedInwarding} path="/companyP&L/rejectedInwarding" exact />
			<PrivateRoute component={DownloadGRN} path="/companyP&L/download-grn" exact />
			<PrivateRoute component={POEditRequests} path="/companyP&L/poEditRequest" exact />
			<PrivateRoute component={POEditRequestsL1} path="/companyP&L/poEditRequestL1" exact />
			{/* <PrivateRoute component={pendingInwardingApprovals} path="/companyP&L/pendingInwardingApprovals" exact /> */}
			{/* <PrivateRoute component={MultiCheckCreatePo} path="/items-to-be-ordered" exact /> */}
			<PrivateRoute component={MultiCheckCreatePo} path="/items-below-MOQ" exact />
			<PrivateRoute component={WorkingDrawingReceived} path="/Working-Drawing-Received" exact />

			{/* Route for Factory Review Sheet Dashboard */}
			<PrivateRoute component={FactoryReviewSheet} path="/factory-review-sheet" exact />
			{ userDetails?.roles.find((role) => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User || role.name === ROLENAME.Admin || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager) && <PrivateRoute component={chmTicketForm} path="/CHM-Ticket-Creation" exact /> }
			{/* { !userDetails?.roles.find((role) => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User || role.name === ROLENAME.Admin || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager) && <PrivateRoute component={CHMuserDashboard} path="/AssignedCHMticket" exact /> } */}
			{/* { userDetails?.roles.find((role) => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User || role.name === ROLENAME.Admin || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.OperationHead) && <PrivateRoute component={CHMuserDashboard} path="/CHMuserDashboard" exact />} */}
			{ <PrivateRoute component={CHMuserDashboard} path="/CHMuserDashboard" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin) && <PrivateRoute component={ChmAddTicketCategory} path="/ChmAddTicketCategory" exact />}
			<PrivateRoute component={PaymentGenrateLink} path="/payment-genrate-link-approval" exact />
			<PrivateRoute component={CustomerLoginActivity} path="/customer-login-activity" exact />
			<PrivateRoute component={ErpLoginActivity} path="/erp-login-activity" exact />
			<PrivateRoute component={CacheSessionManagement} path="/cache-session-management" exact />
			<PrivateRoute component={UserAccessManagement} path="/accessmanagement" exact />
			<PrivateRoute component={callCenterDashboard} path="/call_center_dashboard" exact />
			{ <PrivateRoute component={TaskManagementDashBoard} path="/Task-Management-DashBoard" exact />}
			{ <PrivateRoute component={TaskManagementNotesDashboard} path="/task-management-notes-dashBoard" exact />}

			{/* Removed Routes */}
			{/* <PrivateRoute component={OperationOne} path="/operation_one" exact /> */}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={leadToMeeting} path="/Lead-To-Meeting" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={meetingToOrder} path="/Meeting-To-Order" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={leadToOrder} path="/Lead-To-Order" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={leadInMarketing} path="/Lead-In-Marketing" exact />}
			{ userDetails?.roles.find((role) => role.name === ROLENAME.Admin || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AGMSales) && <PrivateRoute component={leadsAssigned} path="/Lead-Assigned" exact />}

			<PrivateRoute component={SalesUserWonDealPending} path="/designer-assignment/Won-Deals-Pending-Designer-Assignment" exact />
			{/* Refund request approval component + positive negative CR raise dashboard component */}
			<PrivateRoute component={RefundRequestApprovalView} path="/refund-request-approval" exact />
			<PrivateRoute component={RaiseRefundRequest} path="/raise-refund-request" exact />
			<PrivateRoute component={RefundApproval} path="/refund-approval" exact />
			<PrivateRoute component={RefundApprovalBypass} path="/refund-approval-bypass" exact />
			<PrivateRoute component={RaiseQuotationChangeRequest} path="/raise-positive-negative-cr-request" exact />
			{/* sales target and performance route */}
			<PrivateRoute component={SalesTarget} path="/target" exact />
	        <PrivateRoute component={PerformanceSales} path="/performance" exact />
			<PrivateRoute component={Incentives} path="/incentives" exact />
	        <PrivateRoute component={ParentComponent} path="/lead-builder" exact />
			{/* Route for PO/SO approved by kanishka dashboard */}
			<PrivateRoute component={ApproveStdRateOfMaterial} path="/po-so-standard-rate-approval" exact />
			<PrivateRoute component={Reports} path="/po-so-reports" exact />
			<PrivateRoute component={CurrentMonthPipelineDashboard} path="/current-month-pipeline" exact />
			<PrivateRoute component={ProjectionAcvDashboard} path="/projection-acv" exact />
			<PrivateRoute component={ExpectedClosureTracker} path="/expected-closure-tracker" exact />
			<PrivateRoute component={MeetingTrackerDashboard} path="/meeting-tracker" exact />
			<PrivateRoute component={RncRevivalDashboard} path="/rnc-revival" exact />
			<PrivateRoute component={SalesLostRevivalDashboard} path="/sales-lost-revival" exact />
			<PrivateRoute component={StageReview} path="/stage-review" exact />
			<PrivateRoute component={ReminderDashboard} path="/reminder-dashboard" exact />
			<PrivateRoute component={TeamUserLogs} path="/team-user-logs" exact />
			<PrivateRoute component={MoveToMarketingApproval} path="/move-to-marketing-approval" exact />
			<PrivateRoute component={ProjectManagementDashboard} path="/project-management/dashboard" exact />
			<PrivateRoute component={CreateProject} path="/project-management/create-project" exact />
			<PrivateRoute component={Referral} path="/Referral" exact />
			<PrivateRoute component={CallRecordingsUntagged} path="/call-detail-recordings-untagged" exact />
			<PrivateRoute component={CallRecordingsTagged} path="/call-detail-recordings-tagged" exact />
			<PrivateRoute component={MarketingToBeCalled} path="/leadInfo/to-be-called" exact />
			<PrivateRoute component={MarketingOnHold} path="/leadInfo/on-hold" exact />
			<PrivateRoute component={ChannelPartnerMeetingData} path="/channelpartner-meetingdata" exact />
			<PrivateRoute component={MarketingOnNTBCHold} path="/leadInfo/on-ntbc-hold" exact />
			<PrivateRoute component={MarketingJunk} path="/leadInfo/junk" exact />
		 	<PrivateRoute component={LeadReturnBySale} path="/lead-returned-by-sales" exact />
        	<PrivateRoute component={CallLogsForLead} path="/call-detail-recordings/:leadId" exact />
			<PrivateRoute component={TaxInvoicesListing} path="/tax-invoices" exact />
        	<PrivateRoute component={CallReport} path="/call-report" exact />

			<PrivateRoute component={MaterialsCheckListApprovals} path="/materials-checklist-approvals" exact />
			<PrivateRoute component={IncomingWhatsAppMessages} path="/incoming-whatsapp-messages/" exact />	
			<PrivateRoute component={TargetForDesignTeam} path="/target-for-design-team" exact />
            <PrivateRoute component={PerformanceForDesignTeam} path= "/performance-for-design-team" exact />
            <PrivateRoute component={IncentiveForDesignTeam} path="/incentive-for-design-team" exact />


			<PrivateRoute component={MyProjectManagementDashboard} path="/project-management/my-dashboard" exact />
            <PrivateRoute component={CapexProjectCreation} path="/project-management/create-capex-project" exact />
            <PrivateRoute component={CapexProjectApproval} path="/project-management/approve-capex-projects" exact />
			<PrivateRoute component={SnagSeriesCreation} path="/project-management/create-snag-series" exact />
            <PrivateRoute component={OverheadProjectCreation} path="/project-management/create-overhead-project" exact />
            <PrivateRoute component={OverheadProjectApproval} path="/project-management/approve-overhead-projects" exact />

			<PrivateRoute component={ScanPiece} path="/scan-piece" exact />
			<PrivateRoute component={InTransit} path="/in-transit-projects" exact />
			<PrivateRoute component={ScanPackageReport} path="/scanPackageLogs" exact />
			
			<PrivateRoute component={AutomationLeadDashboard} path="/automation-lead-summary/" exact />
			<PrivateRoute component={RedirectEC} path="/redirect-ec/" exact />
			<PrivateRoute component={logDetailed} path="/userManagement/logDetailed" exact />
			<PrivateRoute component={MonthlyConversionGoals} path="/set-monthly-conversion-goal" exact />
			<PrivateRoute component={inwardingLockDate} path="/inwarding-lock-date" exact />
			<PrivateRoute component={OperationStage} path="/so-payment-request-approval/so" exact />
			<PrivateRoute component={VendorPaymentSO} path="/finance/payment/vendor-SO-payment" exact />
			<PrivateRoute component={VendorPaymentPO} path="/finance/payment/vendor-PO-payment" exact />
			<PrivateRoute component={HDFCResponse} path="/finance/HDFCResponse" exact />
			<PrivateRoute component={DrawingQcApproval} path="/drawing-qc-approval" exact />
			<PrivateRoute component={AdmCheckList} path="/adm-check-list" exact />
			<PrivateRoute component={OverviewQCTable} path="/overview-qc-table" exact />
			<PrivateRoute component={DrawingQCTable} path="/drawing-qc-table" exact />
			<PrivateRoute component={DrawingQCLogs} path="/drawing-qc-logs" exact />

			<PrivateRoute component={DesignHealth} path="/design-health-summary" exact />
			<PrivateRoute component={DesignHealthMDaySummary} path="/design-health-m-day-summary" exact />
			<PrivateRoute component={OdmAgmMyCommitments} path="/my-commitments" exact />
			<PrivateRoute component={OdmAgmPendingTask} path="/pending-task" exact />
			<PrivateRoute component={OdmAgmPerformanceDashboard} path="/odm-agm-performance-dashboard" exact />
			<PrivateRoute component={MyTeamPerformance} path="/my-team-performance" exact />
			<PrivateRoute component={TeamBandwidth} path="/team-bandwidth" exact />
			<PrivateRoute component={OdmAgmApprovals} path="/odm-agm-approvals" exact />
			<PrivateRoute component={OdmAgmSummaryDashboard} path="/odm-agm-summary-dashboard" exact />
			<PrivateRoute component={MonthlyContract} path="/monthly-contract" exact />
			<PrivateRoute component={CommitmentApprovalForADM} path="/commitment-approval" exact />
			<PrivateRoute component={FreezeProjects} path="/freezing-projects" exact />

			<PrivateRoute component={PartnersImg} path="/settings/webQuotation/partner-img" exact />
			<PrivateRoute component={socialMediaWebQuotation} path="/settings/webQuotation/social-media" exact />

			<PrivateRoute component={CostSummarySection} path="/settings/webQuotation/CostSummarySection" exact />
			<PrivateRoute component={CostBreakDownSection} path="/settings/webQuotation/CostBreakDownSection" exact />
			<PrivateRoute component={whyChooseUsNew} path="/settings/webQuotation/whyChooseUs" exact />
			<PrivateRoute component={customerTestimonials} path="/settings/webQuotation/customerTestimonials" exact />
			<PrivateRoute component={galleryWebQuotation} path="/settings/webQuotation/galleryWebQuotations" exact />
			<PrivateRoute component={flaggedProject} path="/flagged-projects" exact />
			<PrivateRoute component={SpendReport} path="/spend-report" exact />
			<PrivateRoute component={SpendReportValues} path="/spend-report-values" exact />
			<PrivateRoute component={ManualReferral} path= "/settings/referral/manual-referral" exact />
			<PrivateRoute component={DesignNewSummary} path="/my-summary-dashboard" exact />
            <PrivateRoute component={PerformanceDashboardDesignTeam} path= "/performance-Dashboard-design-team" exact />
            <PrivateRoute component={Approval} path= "/my-design-approval" exact />
			<PrivateRoute component={LeadLifeCycle} path= "/lead-life-cycle" exact />
			<PrivateRoute component={ChannelPartner} path= "/channel-partner" exact />
			<PrivateRoute component={ChannelPartnerPerformance} path= "/channel-partner-performance" exact />
			<PrivateRoute component={WhatsAppCampaign} path= "/whats-app-dashboard" exact />
			<PrivateRoute component={HoomanAvailabilityDashboard} path= "/hooman-availability-dashboard" exact />
			<PrivateRoute component={HoldDashboard} path= "/hold-dashboard" exact />
			<PrivateRoute component={InitiationBomDataTable} path= "/initiation-bom-data-table" exact />
			<PrivateRoute component={bomSegregation} path= "/bom-segregation" exact />
			<PrivateRoute component={addGSTPage} path= "/add-gst-number" exact />
			<PrivateRoute component={updateSalesWonDate} path= "/update-sales-won-date" exact />
			<PrivateRoute component={MyNotifications} path= "/my-notifications" exact />
			<PrivateRoute component={SalesOverallComparison} path= "/sales-overall-comparison" exact />
			<PrivateRoute component={LeadHealthAnalytics} path= "/lead-health-analytics" exact />
			<PrivateRoute component={XoxodayForm} path="/xoxoday-form" exact />
			<PrivateRoute component={FurnitureOne} path= "/furniture-one-project-details" exact />
			<PrivateRoute component={updateFurnitureOneItems} path= "/settings/furniture-one-project-details" exact />
			<PrivateRoute component={FurnitureOneItemDetails} path= "/furniture-one-item-details" exact />
			<PrivateRoute component={FurnitureOneApproval} path= "/furniture-one-approvals-section" exact />
			<PrivateRoute component={ERPSMainPage} path= "/employee-rewards-points-system-designer" exact />
			<PrivateRoute component={RewardConfig} path= "/erps/config" exact />
			<PrivateRoute component={hrStatusColorCode} path= "/hr-status-color-code" exact />
            <PrivateRoute component={roster} path= "/roster" exact />
            <PrivateRoute component={hrRacksheetOverallSummary} path= "/hr-racksheet-overall-summary" exact />  
            <PrivateRoute component={hrRacksheetSummaryByCity} path= "/hr-racksheet-summary-by-city" exact />
            <PrivateRoute component={hrRacksheetSummaryByEC} path= "/hr-racksheet-by-ec" exact />  
            <PrivateRoute component={hrRacksheetOpenReq} path= "/hr-racksheet-open-req" exact />    
            <PrivateRoute component={hrRacksheetAtRisk} path= "/hr-racksheet-at-risk" exact />  
            <PrivateRoute component={hrRacksheetDesignHierarchy} path= "/hr-racksheet-design-hierarchy" exact />    
            <PrivateRoute component={hrRacksheetSalesHierarchy} path= "/hr-racksheet-sales-hierarchy" exact />  
            <PrivateRoute component={hrRacksheetOpsHierarchy} path= "/hr-racksheet-ops-hierarchy" exact /> 
			<PrivateRoute component={RfdExecutiveDashboarad} path= "/rfd-executive-dashboard" exact />
			<PrivateRoute component={ManagerDashboard} path= "/rfd-manager-dashboard" exact />
            <PrivateRoute component={PanelDeliveryReports} path="/panel-delivery-reports" exact />
            <PrivateRoute component={FullPackageDelivered} path="/full-package-delivered" exact />
            <PrivateRoute component={PartialPackageDelivered} path="/partial-package-delivered" exact />
            <PrivateRoute component={SnagDetails} path="/snag-details" exact />
            <PrivateRoute component={HardwareSnags} path="/hardware-snags" exact />
            <PrivateRoute component={HardwareBomViewer} path="/hardware-bom" exact />
            <PrivateRoute component={ProductionSummaryProject} path="/production-summary-project" exact />
            <PrivateRoute component={ExecutionApprovalList} path= "/execution-review-list" exact /> 
			<PrivateRoute component={hrRacksheetActivityLogDashboard} path= "/hr-racksheets-activity-log" exact />
			<PrivateRoute component={KekaRoles} path="/userManagement/keka-roles" exact />
			<PrivateRoute component={KekaDepartments} path="/userManagement/keka-departments" exact />
			<PrivateRoute component={KekaCities} path="/userManagement/keka-cities" exact />
			<PrivateRoute component={KekaExperienceCenters} path="/userManagement/keka-experience-centers" exact />	
			<PrivateRoute component={VendorLogs} path="/vendorManagement/vendorLogs" exact />
			{/* Rental on-Boardning Page for Rental and Service Order */}
			<PrivateRoute component={RentalOwnerOnboarding} path= "/rental-onboarding/for-miscpayment" exact />
			<PrivateRoute component={ChannelPartnerOnboarding} path= "/channel-partner-onboarding/for-miscpayment" exact />
			{/* Misc Payment Raise */}
			<PrivateRoute component={MiscPaymentRaise} path= "/raise-misc-payment/for-miscpayment" exact />
			{/* onboarding approval for Rental and Service Order */}
			<PrivateRoute component={OnboardningRaiseApproval} path= "/onboarding-rental-service-approval/for-miscpayment" exact />
			{/* status page for rental and service order approval */}
			<PrivateRoute component={OnboardingApprovalStatusView} path= "/onboarding-rental-service-status/for-miscpayment" exact />
			{/* payment raised status page for rental and service order approval */}
			<PrivateRoute component={PaymentRaisedStatusView} path= "/misc-payment-raised-status/for-miscpayment" exact />
			{/* master payment dashboard for rental and service order approval */}
			<PrivateRoute component={MiscpaymentMasterDashboard} path= "/misc-payment-master-dashboard/for-miscpayment" exact />
			 {/* payment page for finance where send to snorkel/hdfc */}
			<PrivateRoute component={MiscpaymentMasterFinanceDashboard} path= "/misc-payment-master-dashboard-finance/for-miscpayment" exact />
			 {/* comparison page for payments.. */}
			<PrivateRoute component={RentalPaymentDashboardComparison} path= "/misc-payment-rental-comparison-chart/for-miscpayment" exact />
			<PrivateRoute component={ManageMiscPaymentServiceTypes} path="/masterManagement/miscPaymentServiceTypes" exact />
			<PrivateRoute component={ManageMiscPaymentServiceCaps} path="/masterManagement/miscPaymentServiceCaps" exact />
			<PrivateRoute component={ApprovalCenter} path="/site-visit-approval-center" exact />
			<PrivateRoute component={StockMovement} path= "/stock-movement" exact />
			<PrivateRoute component={StockMovementLog} path= "/stock-movement-logs" exact />
			<PrivateRoute component={GstPaymentApproval} path="/so-payment-request-approval/gst" exact />
			<PrivateRoute component={pushToProd} path= "/push-to-prod" exact />
			<PrivateRoute component={MoqAndOrders} path="/moq-and-orders" exact />
	        <PrivateRoute component={RouteAccessManagement} path="/userManagement/route-access" exact />
            <PrivateRoute component={leadAccessGrants} path="/lead-access-grants" exact />
			<PrivateRoute component={discountApprovalHistory} path="/discount-approval-history" exact />

			<UnknownRouteFallback />
		</>
	)
}

export default Index